import styled from '@emotion/styled'
import { Table } from 'antd'

export default styled(Table)`
  td,
  th {
    word-break: normal;
    -ms-word-break: normal !important;
    padding: 5px 8px !important;
    vertical-align: top;
  }

  td div {
    overflow-x: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chec-table-row {
    height: 32px;

    & > td {
      padding: 5px 8px !important;
      /* needs !important to override ant */
    }
  }

  /* Fudge for now to mitigate exra td width in excess of div size.
   If we do nowrap-table-cell...  */
  .nowrap-table-cell {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  td.table-column-danger {
    color: #b4040c;
  }
`
